export const locationsUr = {
  locations: {
    type: {
      factory: 'فیکٹری',
      office: 'دفتر',
      unknown: 'نامعلوم',
    },
  },
  header: {
    selectLocation: 'مقام منتخب کریں',
    searchLocations: 'مقامات تلاش کریں...',
    allLocations: 'تمام مقامات',
  },
}
